import React from 'react';
import {
  Grid,
  Typography,
  ListItemAvatar,
  ListItemText,
  List,
  ListItem,
  SvgIcon
} from '@mui/material';

import { ReactComponent as DroneIcon } from '../../../../assets/svgs/DroneIcon.svg';
import { ReactComponent as DroneBlack } from '../../../../assets/svgs/DroneBlack.svg';
import { ReactComponent as DroneBlue } from '../../../../assets/svgs/DroneBlue.svg';
import { ReactComponent as DroneRed } from '../../../../assets/svgs/DroneRed.svg';
import { ReactComponent as DroneYellow } from '../../../../assets/svgs/DroneYellow.svg';
import { useDispatch } from 'react-redux';
import { chooseAircraft } from 'actions/liveAircraftActions';

export const uavIcons = {
  black: DroneBlack,
  blue: DroneBlue,
  yellow: DroneYellow,
  red: DroneRed
};
export const AircraftList = props => {
  const dispatch = useDispatch();
  const minimal = true;

  return (
    <List style={{ maxWidth: 600 }}>
      {props?.uavs.map((uav, i) => {
        const lastUpdated = (Date.now() - uav?.lastTelemetry) / 1000;
        const onClickAircraft = () => {
          dispatch(chooseAircraft(uav));
        };
        const Colour = uavIcons[uav?.colour];
        if (minimal) {
          return (
            <ListItem
              key={`minimal-ac-list-item-${i}`}
              alignItems="flex-start"
              style={{ minHeight: 120 }}
              className="p-4 hover:scale-95 cursor-pointer"
              onClick={onClickAircraft}>
              <Grid container direction="column">
                <Grid container direction="row">
                  <Grid item>
                    <ListItemAvatar color="primary">
                      <SvgIcon
                        style={{
                          height: 64,
                          width: 64,
                          alignItems: 'center',
                          alignSelf: 'center'
                        }}
                        color="primary">
                        <Colour
                          style={{ alignItems: 'center', alignSelf: 'center' }}
                          color="primary"
                        />
                      </SvgIcon>
                    </ListItemAvatar>
                  </Grid>

                  <Grid item xs={6}>
                    <ListItemText
                      primary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="h6"
                            color="text.primary">
                            {`${uav?.sitl ? 'DEV' : 'MNA'}-${uav?.uavId} ${
                              uav?.sitl ? '[SITL]' : ''
                            }`}
                          </Typography>
                        </React.Fragment>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'block' }}
                            component="span"
                            variant="body2"
                            color="text.primary">
                            {uav?.uavState}
                          </Typography>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color={'text.primary'}>
                            {uav?.flightMode}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      sx={{ display: 'inline' }}
                      variant={'caption'}
                      component="span">
                      {Math.round(lastUpdated) < 3
                        ? `Updated now`
                        : `Updated ${Math.round(lastUpdated)} seconds ago`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
          );
        } else {
          return (
            <ListItem alignItems="flex-start" style={{ minHeight: 120 }} key={`ac-list-item-${i}`}>
              <Grid container direction="row">
                <Grid item>
                  <ListItemAvatar color="primary">
                    <SvgIcon
                      style={{
                        height: 64,
                        width: 64,
                        alignItems: 'center',
                        alignSelf: 'center'
                      }}
                      color="primary">
                      <DroneIcon
                        style={{ alignItems: 'center', alignSelf: 'center' }}
                        color="primary"
                      />
                    </SvgIcon>
                  </ListItemAvatar>
                </Grid>

                <Grid item xs={5}>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="h6"
                          color="text.primary">
                          {`${uav?.sitl ? 'DEV' : 'MNA'}-${uav?.uavId} ${
                            uav?.sitl ? '[SITL]' : ''
                          }`}
                        </Typography>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'block' }}
                          component="span"
                          variant="body2"
                          style={{
                            color: uav?.sims?.[0]?.available
                              ? '#66bb6a'
                              : '#f44336'
                          }}>
                          Sim 1 {uav?.sims?.[0]?.ip}{' '}
                          {uav?.sims?.[0]?.active ? ' (active)' : ''}
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          style={{
                            color: uav?.sims?.[1]?.available
                              ? '#66bb6a'
                              : '#f44336'
                          }}>
                          Sim 2 {uav?.sims?.[1]?.ip}{' '}
                          {uav?.sims?.[1]?.active ? ' (active)' : ''}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  <Typography
                    sx={{ display: 'inline' }}
                    variant={'caption'}
                    component="span">
                    {Math.round(lastUpdated) < 3
                      ? `Updated now`
                      : `Updated ${Math.round(lastUpdated)} seconds ago`}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="h6"
                          color="text.primary">
                          {`Pilots`}
                        </Typography>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'block' }}
                          component="span"
                          variant="body2"
                          color={
                            uav?.pilotInfo?.p1?.connected
                              ? 'secondary'
                              : 'error'
                          }>
                          P1{' '}
                          {uav?.pilotInfo?.p1?.connected
                            ? 'connected'
                            : 'disconnected'}
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color={
                            uav?.pilotInfo?.p2?.connected
                              ? 'secondary'
                              : 'error'
                          }>
                          P2{' '}
                          {uav?.pilotInfo?.p2?.connected
                            ? 'connected'
                            : 'disconnected'}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </Grid>
                <Grid item>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="h6"
                          color="text.primary">
                          {`State`}
                        </Typography>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'block' }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {uav?.uavState}
                        </Typography>
                        <Typography
                          sx={{ display: 'inline' }}
                          component="span"
                          variant="body2"
                          color={'text.primary'}>
                          {uav?.flightMode}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </Grid>
              </Grid>
            </ListItem>
          );
        }
      })}
    </List>
  );
};
